module.exports = __webpack_public_path__ + "static/media/golf.9437f2e0.webp";